import { toast } from "react-hot-toast";
import { studentEndpoints } from "../apis";
import { apiConnector } from "../apiconnecter"
import rzpLogo from "../../assets/Images/rzp.png";
import { setPaymentLoading } from "../../reducer/slices/courseSlice";
import { resetCart } from "../../reducer/slices/cartSlice";
import {enrollStudent} from "../apis";



const {COURSE_PAYMENT_API, COURSE_VERIFY_API, SEND_PAYMENT_SUCCESS_EMAIL_API } = studentEndpoints;
const {ENROLLSTUDENT}=enrollStudent;

function loadScript(src) {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;

        script.onload = () => {
            resolve(true);
        }
        script.onerror= () =>{
            resolve(false);
        }
        document.body.appendChild(script);
    })
}


export async function buyCourse(token, courses, userDetails, navigate, dispatch) {
    const toastId = toast.loading("Loading...");
    try{
        //load the script
        const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

        if(!res) {
            toast.error("RazorPay SDK failed to load");
            return;
        }

        //initiate the order
        const orderResponse = await apiConnector("POST", COURSE_PAYMENT_API, 
                                {courses},
                                {
                                    Authorization: `Bearer ${token}`,
                                })

        if(!orderResponse.data.success) {
            throw new Error(orderResponse.data.message);
        }
        console.log("PRINTING orderResponse", orderResponse);
        //options
        
        const options = {
            key: 'rzp_test_L2xGUPd25MH4Rj',
            currency: `${orderResponse.data.data.currency}`,
            amount: `${orderResponse.data.data.amount}`,
            order_id:orderResponse.data.id,
            name:"StudyNotion",
            description: "Thank You for Purchasing the Course",
            image:rzpLogo,
            prefill: {
                name:`${userDetails.firstName}`,
                email:userDetails.email
            },
            handler: function(response) {
                //send successful wala mail
                // sendPaymentSuccessEmail(response, orderResponse.data.message.amount,token );
                //verifyPayment
                // verifyPayment({...response, courses}, token, navigate, dispatch);
            }
        }
        //miss hogya tha 
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
        paymentObject.on("payment.failed", function(response) {
            toast.error("oops, payment failed");
            console.log(response.error);
        })

    }
    catch(error) {
        console.log("PAYMENT API ERROR.....", error);
        toast.error("Could not make Payment");
    }
    toast.dismiss(toastId);
}
export async function buyFreeCourse(token, courses, userDetails, navigate, dispatch) {

    const toastId = toast.loading("Loading...");
    
    //no fees just enroll the student in the course
    courses.forEach(async (course) => {
        try{
            console.log(course);
            const response = await apiConnector("POST", ENROLLSTUDENT, {
                courseId: course,
            },{
                Authorization: `Bearer ${token}`,
            })
            if(!response.data.success) {
                throw new Error(response.data.message);
            }
            toast.success("Enrolled Successfully");
            
            
        }
        catch(error) {
            console.log("ENROLL STUDENT ERROR....", error);
            toast.error("Could not enroll student");
        }
    }
    )
    toast.dismiss(toastId)
    //reset cart
    dispatch(resetCart());
    navigate("/dashboard/enrolled-courses");

    

}


async function sendPaymentSuccessEmail(response, amount, token) {
    try{
        await apiConnector("POST", SEND_PAYMENT_SUCCESS_EMAIL_API, {
            orderId: response.razorpay_order_id,
            paymentId: response.razorpay_payment_id,
            amount,
        },{
            Authorization: `Bearer ${token}`
        })
    }
    catch(error) {
        console.log("PAYMENT SUCCESS EMAIL ERROR....", error);
    }
}

//verify payment
async function verifyPayment(bodyData, token, navigate, dispatch) {
    const toastId = toast.loading("Verifying Payment....");
    dispatch(setPaymentLoading(true));
    try{
        const response  = await apiConnector("POST", COURSE_VERIFY_API, bodyData, {
            Authorization:`Bearer ${token}`,
        })

        if(!response.data.success) {
            throw new Error(response.data.message);
        }
        toast.success("payment Successful, ypou are addded to the course");
        navigate("/dashboard/enrolled-courses");
        dispatch(resetCart());
    }   
    catch(error) {
        console.log("PAYMENT VERIFY ERROR....", error);
        toast.error("Could not verify Payment");
    }
    toast.dismiss(toastId);
    dispatch(setPaymentLoading(false));
}